import { AdminListMarketsFilter, Market } from '../../graphql/API';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminListMarketsApi = async (filter: AdminListMarketsFilter): Promise<Market[]> => {
  const result = await executeGql<Market[]>(adminListMarketsQuery, { filter });
  return processGqlResult('adminListMarkets.items', result);
};

const adminListMarketsQuery = /* GraphQL */ `
  query AdminListMarkets($filter: AdminListMarketsFilter!) {
    adminListMarkets(filter: $filter) {
      items {
        countryCode
        createdAt
        currency
        country
        id
        name
        percentActiveModels
        percentBookedAllTime
        percentBookedLastFewDays
        stateProvince
        status
        tipEnabled
        totalActiveModels
        totalActiveOffers
        totalActiveVenues
        totalActiveVenueWithOffers
        totalPremiumOffers
        totalPremiumUsers
        totalPremiumVenues
        totalReach
        totalReservations
        totalReservationsLastFewDays
        totalSpots
        totalUsers
        totalVenues
        unitSystem
        valueActiveOfferSpots
        timezone {
          timeZoneId
        }
      }
    }
  }
`;
